<template>
  <div :class="['article', localLang == 'en' ? '' : 'article0']">
    <p class="article-title g-tac g-fwb">{{$t('article0.title')}}</p>
    <p class="article-content">{{$t('article0.p1')}}</p>
    <p class="article-content">{{$t('article0.p2')}}</p>
    <img src="@/assets/article/article0/RedteaSIM_01.jpeg"/>
    <p class="article-content">{{$t('article0.p3')}}</p>
    <p class="article-content">{{$t('article0.p4')}}</p>
    <p class="article-content">{{$t('article0.p5')}}    </p>
    <p class="article-content">{{$t('article0.p6')}}</p>
    <p class="article-content g-fwb">{{$t('article0.p7')}}</p>
    <p class="article-content">{{$t('article0.p8')}}</p>
    <p class="article-content" v-html="$t('article0.p9')"></p>
    <img :src="article0Img1" alt="">
    <img :src="article0Img2" alt="">
    <img src="@/assets/article/article0/RedteaSIM_04.png"/>
    <p class="article-content g-tac g-fwb">{{$t('article0.p10')}}</p>
    <img :src="article0Img3" alt="">
    <p class="article-content g-tac" v-html="$t('article0.p11')"></p>
    <img src="@/assets/article/article0/RedteaSIM_05.png"/>
    <p class="article-content">{{$t('article0.p12')}}</p>
    <p class="article-content">{{$t('article0.p13')}}</p>
    <p class="article-content">{{$t('article0.p14')}}</p>
    <p class="article-content g-tac" v-html="$t('article0.p15')"></p>
    <img src="@/assets/article/article0/RedteaSIM_06.jpg"/>
    <p class="article-content g-txc">{{$t('article0.p16')}}</p>
    <p class="article-content">{{$t('article0.p17')}}</p>
    <p class="article-content">{{$t('article0.p18')}}</p>
    <p class="article-content">{{$t('article0.p19')}}</p>
    <p class="article-content g-tal" v-html="$t('article0.p20')"></p>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState(['article0Img1','article0Img2','article0Img3','localLang']),
  },
}
</script>
<style lang="less">
.article0 {
  .article-content {
    text-align: justify;
  }
}
</style>
